import { useLocalSessionId, useParticipantProperty } from '@daily-co/daily-react';
import { useEffect, useMemo } from 'react';
import useParticipantsArray from "./useParticipantsArray";

export default function useParticipantsWithHost() {
  const all = useParticipantsArray();
  const localSessionId = useLocalSessionId();

  const owner = all.find(p => p.owner);
  const others = all.filter(p => !p.owner).sort((a, b) => a.session_id.localeCompare(b.session_id));

  const ordered = [...others, owner].filter(Boolean); // owner no final, remove undefined

  const participantA = ordered[0] || null;
  const participantB = ordered[1] || null;
  const participantMod = ordered[2] || null;

  // Pega os nomes dos participantes (hooks devem ser chamados sempre)
  const nameA = useParticipantProperty(participantA?.session_id, 'user_name') || null;
  const nameB = useParticipantProperty(participantB?.session_id, 'user_name') || null;
  const nameMod = useParticipantProperty(participantMod?.session_id, 'user_name') || null;

  // Log quando 'all' mudar
  useEffect(() => {
    console.log(all);

    console.log('[useParticipantsWithHost] Mudança detectada:');
    console.log('  A:', nameA || '(nenhum)');
    console.log('  B:', nameB || '(nenhum)');
    console.log('  Mod:', nameMod || '(nenhum)');
  }, [all, nameA, nameB, nameMod]);

  // Identifica o role do usuário atual
  const whoAmI = useMemo(() => {
    if (participantA?.session_id === localSessionId) return 'A';
    if (participantB?.session_id === localSessionId) return 'B';
    if (participantMod?.session_id === localSessionId) return 'Host';
    return null;
  }, [participantA, participantB, participantMod, localSessionId]);

  return { participantA, participantB, participantMod, whoAmI };
}
